console.log("MPA JS LOADED ✅");

(function () {
  let hasRun = false;

  function animateCount(el, target) {
    const duration = 1400;
    const start = performance.now();

    function tick(now) {
      const progress = Math.min((now - start) / duration, 1);
      const value = Math.floor(progress * target);
      el.textContent = value.toLocaleString();

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = target.toLocaleString() + "+";
      }
    }

    requestAnimationFrame(tick);
  }

  function runMPAStatsOnce() {
    if (hasRun) return;

    const container = document.querySelector(".mpa-impact");
    const stats = document.querySelectorAll(".mpa-impact [data-target]");

    console.log("MPA impact found:", !!container);
    console.log("MPA stats found:", stats.length);

    if (!container || stats.length === 0) return;

    hasRun = true;

    stats.forEach(el => {
      const target = parseInt(el.dataset.target, 10);
      if (!Number.isFinite(target)) return;
      animateCount(el, target);
    });
  }

  // Run when section enters view
  document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector(".mpa-impact");
    if (!container) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            runMPAStatsOnce();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.35 }
    );

    observer.observe(container);
  });
})();
